module.exports = __webpack_public_path__ + "media/src/images/icons/arrow_left-5a927029fcb4e3a569b553197c784aeb.svg";